import {Component, OnDestroy, OnInit} from '@angular/core';
import { AccountService} from '../../../services/account.service';
import {Clipboard} from '@angular/cdk/clipboard';
import {CustomerDetailService} from '../../../services/customer-detail.service';
import {CustomerProfileService} from '../../../services/customer-profile.service';
import {CommonComponent} from '../../shared/common/common.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {NotificationsService} from '../../../services/notifications.service';
import {ToastaService} from 'ngx-toasta';
import {Router} from '@angular/router';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {DialogService} from 'primeng/dynamicdialog';
import {NgxQrcodeElementTypes} from '@techiediaries/ngx-qrcode';
import {StorageItem} from '../../../enums/storage-item';
import {Profile} from '../../../domain/authentication/profile';
import {LocalStorageService} from 'angular-2-local-storage';
import {CustomerProfile} from '../../../domain/customer/customer-profile';
import {ApplicationStatus} from '../../../domain/onBoarding/application-body';
import {ReplaySubject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

@Component({
  selector: 'app-referral-code',
  templateUrl: './referral-code.component.html',
  styleUrls: ['./referral-code.component.scss']
})

export class ReferralCodeComponent extends CommonComponent implements OnInit, OnDestroy {
  referralCopyCode: string;
  profileDetail: CustomerProfile;
  referralCode: string;
  // QR Code
  title = 'QR Referral Code';
  elementType = NgxQrcodeElementTypes.URL;
  value: string;
  changeImage = false;
  applicationStatus: string;
  ApplicationStatus = ApplicationStatus;
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);
  constructor(
    private clipboard: Clipboard,
    private accountService: AccountService,
    private customerDetailService: CustomerDetailService,
    private customerProfileService: CustomerProfileService,
    protected modalService: NgbModal,
    protected notificationsService: NotificationsService,
    protected toastService: ToastaService,
    router: Router,
    public translate: TranslateService,
    protected dialogService: DialogService,
    protected localStorage: LocalStorageService,
  ) {
    super(modalService, notificationsService, toastService, router, translate, dialogService);
    const profile: Profile = this.localStorage.get(StorageItem.PROFILE);
    if (profile?.locale) {
      const language = profile.locale.substring(0, 2);
      translate.use(this.getValidLanguage(profile.locale.substring(0, 2)));
      this.changeImage = language === 'en';
    }
    translate.onLangChange.subscribe(
      (event: LangChangeEvent) => {
        this.handleLanguageChange(event.lang);
      });
  }
  ngOnInit(): void {
    this.loadingModalOn();
    this.customerProfileService.customerProfile$.pipe(takeUntil(this.destroyed$)).subscribe(
      (response: any) => {
        this.applicationStatus = response.applicationStatus;
        this.referralCode = response.altairAgentCode;
        this.referralCopyCode = this.referralCode;
        this.loadingModalOff();
    }, error => {
        this.msgError(error);
        this.loadingModalOff();
      }
    );
  }
  copyReferralCode(){
    this.clipboard.copy(this.referralCopyCode.toLowerCase());
  }
  handleLanguageChange(lang: string){
    this.changeImage =  lang === 'en';
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.unsubscribe();
  }
}

